import { FunctionComponent, memo, MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './SkipLink.module.scss';

export const MAIN_CONTENT_ID = 'main-content';

export const SkipLink: FunctionComponent = memo(() => {
  const { t } = useTranslation();

  const skipHandler = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    const main = document.getElementById(MAIN_CONTENT_ID);

    if (!main) {
      return;
    }

    main.setAttribute('tabindex', '-1');
    main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true });
    main.focus();
  }, []);

  return (
    <a className={classes['skip-link']} href={`#${MAIN_CONTENT_ID}`} onClick={skipHandler}>
      {t('common.skip-to-content')}
    </a>
  );
});
